import React, { useState } from "react";
import TablePagination from '@material-ui/core/TablePagination';
import {
  Button, TableRow, Table,TableHead, TableBody, TableCell,
    TableContainer,
          Paper,
          Dialog,
          DialogTitle,
          DialogContent,
          DialogActions,
          FormControlLabel,
          Checkbox,
          CircularProgress,
          Typography,
          IconButton,
          InputAdornment,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import ActivityService from "./Locality/Service/activityService";
import { Grid, } from "@material-ui/core";
import { useFormik } from 'formik';
import {  useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import SchoolService from "./Locality/Service/schoolService";
import AddClassService from "./Locality/Service/addClassService";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function SchoolDetails(props, history) {
    const tableHeaders = ['School Name', 'City',   'Contact Person','Contact Number','Contact Email','Tail subscription' ];
    const classes = useStyles();

    const [schoolList, setSchoolList] = useState([]);
        const [studentList, setStudentList] = useState([]);
    const [schoolSearch, setSchoolSearch] = useState("");

    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(5);
    const [addUserPermitionsList, setUserPermitionsList] = useState({studentDetailsEdit:false, studentDetailsDelete:false});

    const [classesDialogOpen, setClassesDialogOpen] = useState(false);
    const [activeSchool, setActiveSchool] = useState(null);
    const [allClasses, setAllClasses] = useState([]);
    const [selectedClassIds, setSelectedClassIds] = useState([]);
    const [loadingClasses, setLoadingClasses] = useState(false);
    const [classesLoadError, setClassesLoadError] = useState(null);
    const [savingClasses, setSavingClasses] = useState(false);

    const userDetails = localStorage.getItem("userDetail")
      ? JSON.parse(localStorage.getItem("userDetail"))
      : {};
    const canEditClasses =
      userDetails?.role === "SCHOOLE" || userDetails?.role === "SUPERADMIN";
    const isSuperAdmin = String(userDetails?.role || "").toUpperCase() === "SUPERADMIN";

    const [resetPasswordOpen, setResetPasswordOpen] = useState(false);
    const [resetPasswordSchool, setResetPasswordSchool] = useState(null);
    const [resetPasswordValue, setResetPasswordValue] = useState("");
    const [resetPasswordError, setResetPasswordError] = useState("");
    const [resetPasswordSuccess, setResetPasswordSuccess] = useState("");
    const [resetPasswordSaving, setResetPasswordSaving] = useState(false);
    const [resetShowPassword, setResetShowPassword] = useState(false);
    const [school, setSchoool] = useState({
        schooleName: '',
        city: '',
        selectCountry: '',
        name: '',
        email: '',

        mobileNumber: '',
        schooleEmail: '',
        schooleContact: '',
        subscription: '',
    });const handleChangePage=(event, newpage) =>{
        setpg(newpage);
    }
  
    const handleChangeRowsPerPage=(event)=> {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    useEffect(() => {
        
    getStudentListInSchool();
        return () => {
           setStudentList([])
            setSchoolList([]);
           
        }
    }, []);
    const handleOpen = () => {
        props.history.push('/app/studentregistration/add') 
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const onSubmit = data => {
        console.log(JSON.stringify(data, null, 2));
    };
   
    const getUserPermitionsList=()=>{
        const userPermitions= ActivityService.userPermitions();
             setUserPermitionsList(userPermitions);
        }
        
   const getSchoolList = (studentCount) => {
    const students = studentCount || studentList;
    // Create a map for quick lookup
    const studentMap = new Map(students.map(student => [student.schoolId, student.studentCount]));
    SchoolService.getAllSchoolList()
        .then((res) => {
            res.forEach(school => {
                school.studentCount = studentMap.get(school._id) || 0;
            });
            console.log(res);
            setSchoolList(res);
        })
        .catch((err) => {
            // setError(err.message);
        });
}
 const getStudentListInSchool = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        SchoolService.getAllStudentListInSchool().then((res) => {

            setStudentList(res);
            getSchoolList(res);

        }).catch((err) => {
            // setError(err.message);
        });
    }
    const updateStatus = (status,school) => {
        school.status =status
        SchoolService.upadeSchool(school).then((res) => {
            getSchoolList();
        }).catch((err) => {
            // setError(err.message);
        });
    }

    const normalizeClassroomsToIds = (classrooms) => {
      const arr = Array.isArray(classrooms) ? classrooms : [];
      return arr
        .map((x) => (typeof x === "string" ? x : x?._id || x?.id || null))
        .filter(Boolean);
    };

    const ensureAllClassesLoaded = async () => {
      if (allClasses.length > 0) return;
      setLoadingClasses(true);
      setClassesLoadError(null);
      try {
        const res = await AddClassService.getPublicAllClasses();
        setAllClasses(Array.isArray(res) ? res : []);
      } catch (e) {
        setAllClasses([]);
        setClassesLoadError(e?.response?.data?.message || e?.message || "Unable to load classes");
      } finally {
        setLoadingClasses(false);
      }
    };

    const openClassesDialog = async (schoolRow) => {
      setActiveSchool(schoolRow);
      setSelectedClassIds(normalizeClassroomsToIds(schoolRow?.classrooms));
      setClassesDialogOpen(true);
      await ensureAllClassesLoaded();
    };

    const toggleSelectedClass = (classId, checked) => {
      setSelectedClassIds((prev) => {
        const next = new Set(prev || []);
        if (checked) next.add(classId);
        else next.delete(classId);
        return Array.from(next);
      });
    };

    const saveSchoolClasses = async () => {
      if (!activeSchool?._id) return;
      try {
        setSavingClasses(true);
        await SchoolService.upadeSchool({ ...activeSchool, classrooms: selectedClassIds });
        setClassesDialogOpen(false);
        setActiveSchool(null);
        getSchoolList();
      } catch (e) {
        alert(e?.response?.data?.message || e?.message || "Unable to save classes");
      } finally {
        setSavingClasses(false);
      }
    };

    const openResetPasswordDialog = (schoolRow) => {
      setResetPasswordSchool(schoolRow);
      setResetPasswordValue("");
      setResetPasswordError("");
      setResetPasswordSuccess("");
      setResetShowPassword(false);
      setResetPasswordOpen(true);
    };

    const closeResetPasswordDialog = () => {
      if (resetPasswordSaving) return;
      setResetPasswordOpen(false);
      setResetPasswordSchool(null);
      setResetPasswordValue("");
      setResetPasswordError("");
      setResetPasswordSuccess("");
    };

    const handleResetSchoolPassword = () => {
      if (!resetPasswordSchool?._id) return;
      const password = resetPasswordValue.trim();
      if (!password) {
        setResetPasswordError("Password is required.");
        return;
      }
      if (password.length < 6) {
        setResetPasswordError("Password must be at least 6 characters.");
        return;
      }
      setResetPasswordSaving(true);
      setResetPasswordError("");
      SchoolService.resetSchoolPassword(resetPasswordSchool._id, { password })
        .then((res) => {
          const data = res?.data || res;
          setResetPasswordSuccess(
            data?.message ||
              `Password reset successfully for ${resetPasswordSchool.schooleName || "school"}.`,
          );
        })
        .catch((err) => {
          setResetPasswordError(
            err?.response?.data?.message || "Failed to reset password. Please try again.",
          );
        })
        .finally(() => setResetPasswordSaving(false));
    };
 
    // const deleteStudent= (studentdelete) => {
    //     if (studentdelete) {
    //         StudentService.deleteStudent(studentdelete).then((res) => {
    //             getStudentList();
    //         }).catch((err) => {
    //         });
    //     }
    // };
    const formik = useFormik({
        initialValues: school,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
        //   StudentService.upadeStudent(values).then((res) => {
        //     alert(" Updated Successfully.");
        //   })
        //     .catch((err) => {
        //       alert(err.response.data.message)
        //     })
        },
      });

    const filteredSchoolList = schoolSearch
      ? schoolList.filter((s) =>
          String(s?.schooleName || "")
            .toLowerCase()
            .includes(String(schoolSearch).toLowerCase().trim()),
        )
      : schoolList;
    return (
        <>
            <PageTitle title="School Details"  />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <div style={{ padding: 12 }}>
                          <TextField
                            label="Search by school name"
                            variant="outlined"
                            size="small"
                            fullWidth
                            value={schoolSearch}
                            onChange={(e) => {
                              setSchoolSearch(e.target.value);
                              setpg(0);
                            }}
                            placeholder="Type school name..."
                          />
                        </div>
                                                                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                        
                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow> 
                        
                                <StyledTableCell>S.NO</StyledTableCell>
                                <StyledTableCell >School Name</StyledTableCell>
                                <StyledTableCell >City</StyledTableCell>
                                <StyledTableCell >Contact Person</StyledTableCell>
                                <StyledTableCell >Contact Number</StyledTableCell>
                                <StyledTableCell >Contact Email</StyledTableCell>
                                <StyledTableCell >School Number</StyledTableCell>
                                <StyledTableCell >School Email</StyledTableCell>
                                {/* <StyledTableCell >Tail subscription</StyledTableCell> */}
                                <StyledTableCell >Staus</StyledTableCell>
  <StyledTableCell >Students count</StyledTableCell>
                                <StyledTableCell >Classes</StyledTableCell>
                                {isSuperAdmin ? <StyledTableCell>Reset Password</StyledTableCell> : null}
                                          {/* {addUserPermitionsList && addUserPermitionsList.studentDetailsDelete ?
                                        <StyledTableCell >Delete</StyledTableCell>: null } */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredSchoolList.slice(pg * rpg, pg * rpg + rpg).map((school, idx) => (
                                    <TableRow key={school._id}>
                                        <TableCell className="pl-3 fw-normal">{pg * rpg + idx + 1}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{school.schooleName}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{school.city}</TableCell>

                                        <TableCell className="pl-3 fw-normal" >{school.name}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{school.mobileNumber}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{school.email}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{school.schooleContact}</TableCell>

                                        <TableCell className="pl-3 fw-normal" >{school.schooleEmail}</TableCell>
                                        {/* <TableCell className="pl-3 fw-normal" >{school.subscription}</TableCell> */}
                                        <TableCell className="pl-3 fw-normal">
                                        {school.status?  <Button  variant="contained" color="error" style={{backgroundColor:'green', color:'white'}} onClick={() => updateStatus(false, school)}> InActive</Button> : <Button  variant="contained" color="success" style={{backgroundColor:' #e01717', color:'white'}} onClick={() => updateStatus(true, school)}> Active</Button>}
                                        </TableCell>
                                                                                <TableCell className="pl-3 fw-normal" >{school.studentCount}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                          {canEditClasses ? (
                                            <Button
                                              variant="outlined"
                                              size="small"
                                              style={{ borderColor: "#0f3b62", color: "#0f3b62" }}
                                              onClick={() => openClassesDialog(school)}
                                            >
                                              Edit Classes
                                            </Button>
                                          ) : (
                                            <span style={{ color: "#9ca3af" }}>—</span>
                                          )}
                                        </TableCell>
                                        {isSuperAdmin ? (
                                          <TableCell className="pl-3 fw-normal">
                                            <VpnKeyIcon
                                              style={{ cursor: "pointer", color: "#0f3b62" }}
                                              titleAccess="Reset school password"
                                              onClick={() => openResetPasswordDialog(school)}
                                            />
                                          </TableCell>
                                        ) : null}

                                        {/* { addUserPermitionsList.studentDetailsEdit ? 
                                        <TableCell>
                                            <EditIcon style={{ cursor: 'pointer' }} onClick={() => editStudent(student._id, student)} >
                                            </EditIcon >
                                        </TableCell>: null } */}
                                        {/* { addUserPermitionsList.studentDetailsDelete ?
                                        <TableCell>
                                            <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteStudent(student._id)} />
                                        </TableCell>: null } */}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[5, 50, 500, 10000]}
                            count={filteredSchoolList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>

            <Dialog
              open={classesDialogOpen}
              onClose={() => (savingClasses ? null : setClassesDialogOpen(false))}
              fullWidth
              maxWidth="sm"
            >
              <DialogTitle>
                Edit Classes{activeSchool?.schooleName ? ` - ${activeSchool.schooleName}` : ""}
              </DialogTitle>
              <DialogContent dividers>
                {loadingClasses ? (
                  <div style={{ display: "flex", alignItems: "center", gap: 10, padding: 10 }}>
                    <CircularProgress size={18} />
                    <span>Loading classes...</span>
                  </div>
                ) : classesLoadError ? (
                  <div style={{ color: "#b91c1c", padding: 10 }}>{classesLoadError}</div>
                ) : allClasses.length === 0 ? (
                  <div style={{ color: "#6b7280", padding: 10 }}>No classes found</div>
                ) : (
                  <Grid container spacing={1}>
                    {allClasses.map((c) => {
                      const classId = c?._id || c?.id || c?.classId;
                      const className = c?.className || c?.name || "";
                      if (!classId || !className) return null;
                      const checked = (selectedClassIds || []).includes(classId);
                      return (
                        <Grid item xs={12} sm={6} key={classId}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                checked={checked}
                                onChange={(e) => toggleSelectedClass(classId, e.target.checked)}
                              />
                            }
                            label={className}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setClassesDialogOpen(false)}
                  disabled={savingClasses}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#0f3b62", color: "white" }}
                  onClick={saveSchoolClasses}
                  disabled={savingClasses || loadingClasses || !!classesLoadError}
                >
                  {savingClasses ? "Saving..." : "Save"}
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={resetPasswordOpen}
              onClose={closeResetPasswordDialog}
              fullWidth
              maxWidth="xs"
            >
              <DialogTitle>Reset School Password</DialogTitle>
              <DialogContent dividers>
                {resetPasswordSuccess ? (
                  <Typography style={{ color: "#1a9b54", fontWeight: 600 }}>
                    {resetPasswordSuccess}
                  </Typography>
                ) : (
                  <>
                    <Typography variant="body2" style={{ color: "#46566b", marginBottom: 16 }}>
                      Set a new login password for{" "}
                      <strong>{resetPasswordSchool?.schooleName || "this school"}</strong>.
                      The school signs in with their mobile number and this password.
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="New Password"
                      autoComplete="new-password"
                      type={resetShowPassword ? "text" : "password"}
                      value={resetPasswordValue}
                      onChange={(e) => {
                        setResetPasswordValue(e.target.value);
                        if (resetPasswordError) setResetPasswordError("");
                      }}
                      error={Boolean(resetPasswordError)}
                      helperText={resetPasswordError || "Minimum 6 characters (required)"}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setResetShowPassword((v) => !v)}
                              edge="end"
                            >
                              {resetShowPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={closeResetPasswordDialog} disabled={resetPasswordSaving}>
                  {resetPasswordSuccess ? "Close" : "Cancel"}
                </Button>
                {!resetPasswordSuccess ? (
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#0f3b62", color: "white" }}
                    onClick={handleResetSchoolPassword}
                    disabled={resetPasswordSaving || !resetPasswordValue.trim()}
                  >
                    {resetPasswordSaving ? "Updating…" : "Update Password"}
                  </Button>
                ) : null}
              </DialogActions>
            </Dialog>
            
        </>
    );
}


